(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('custactCalcJobExit', {
        templateUrl: 'views/components/views/custactCalcJobExit/custactCalcJobExit.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'custactCalcJobExitService', function ($stateParams, stateService, custactCalcJobExitService) {

            // #region VARIABLES & DEFINITIONS
            
            const vm = this;
            let labourNo = $stateParams.labour_no;
            let custactCalcCustactNo = $stateParams.custactcalc_custact_no;
            let functionName = $stateParams.function_name;

            vm.model = {
                menu: {},
                itemsListFinishedJobs: []
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE CALLS
            
            async function loadMenu() {
                vm.model.menu = (await custactCalcJobExitService.getMenu({
                    labour_no: labourNo,
                    custact_no: custactCalcCustactNo,
                    function_name: functionName
                }))[0];
            }
            
            async function loadFinishedJobs() {
                vm.model.itemsListFinishedJobs = await custactCalcJobExitService.listFinishedJobs({
                    labour_no: labourNo,
                    custact_no: custactCalcCustactNo,
                    function_name: functionName
                });
            }
            
            // #endregion LOAD PROCEDURE CALLS

    		// #region SEARCH PROCEDURE CALL
    		
            vm.clickItem = function (item) {
                custactCalcJobExitService.setCustactNo({
                    labour_no: labourNo,
                    custact_no: item.item_id
                }).then(function () {
                    stateService.go(item.item_state, item.item_parms);
                });
            }

            // #endregion SEARCH PROCEDURE CALL

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                loadMenu();
                loadFinishedJobs();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
